import { useQuery } from "@tanstack/react-query"
import { whatsappNumbersQuery } from "../../lib/whatsapp/whatsappNumbersQuery"

export function useWhatsappNumbersQuery(...args: Parameters<typeof whatsappNumbersQuery>) {
  return useQuery(whatsappNumbersQuery(...args))
}
